import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/components/BlockDefinition';
import type { BlockType, ComponentTypeUnionType } from '@unifyapps/defs/types/block';
import _pick from 'lodash/pick';
import { lazy } from 'react';
import type {
  BusinessHoursBlockStateType,
  BusinessHoursComponentType,
} from '@unifyapps/defs/blocks/BusinessHours/types';
import { getSelectedDataSourcePath } from '@unifyapps/carbon/utils/getSelectedDataSourcePath';
import { DependencyPaths } from '@unifyapps/carbon/no-code/helper/DependencyPaths';
import { defaultBusinessHourValue } from './consts';

const importBusinessHoursComponent = () =>
  import(
    /* webpackChunkName: "business-hours-block" */
    './BusinessHours'
  );

const BusinessHours = lazy(importBusinessHoursComponent);

class BusinessHoursBlockStateDefinition implements BlockStateDefinition {
  get type(): ComponentTypeUnionType {
    return 'BusinessHours';
  }

  get initialStateGetter() {
    return (block: BlockType): BusinessHoursBlockStateType =>
      ({
        id: block.id,
        ..._pick(block.component as BusinessHoursComponentType, [
          'content',
          'appearance',
          'componentType',
        ]),
        value: defaultBusinessHourValue,
      }) as BusinessHoursBlockStateType;
  }

  getComponent() {
    return BusinessHours;
  }

  preload() {
    return {
      blockPreload: importBusinessHoursComponent,
    };
  }

  getImplicitDependencies(block: BlockType<BusinessHoursComponentType>) {
    const { dataSourceId } = getSelectedDataSourcePath({ data: block.component.content.value });
    if (!dataSourceId) return;
    const paths = DependencyPaths.dataSource(dataSourceId);

    return [
      {
        id: dataSourceId,
        p: [paths.isLoading],
      },
    ];
  }
}

export default BusinessHoursBlockStateDefinition;
